export const getTenantVanityFromHost = (): string => {
  const hostname = window.location.hostname.toLowerCase();
  const baseDomain = process.env.REACT_APP_BASE_DOMAIN?.toLowerCase();

  if (baseDomain && hostname.endsWith(`.${baseDomain}`)) {
    return hostname.slice(0, -(baseDomain.length + 1));
  }

  const firstLabel = hostname.split('.')[0];
  return firstLabel && !firstLabel.includes('localhost') ? firstLabel : '';
};

export const getLoginAgainUrl = (): string => {
  const loginPortalUrl = process.env.REACT_APP_LOGIN_URL || '';
  const vanity = getTenantVanityFromHost();

  if (loginPortalUrl && vanity) {
    const base = loginPortalUrl.replace(/\/+$/, '');
    return `${base}/${encodeURIComponent(vanity)}`;
  }

  return loginPortalUrl || '/';
};
